import { Button, Checkbox, FormControlLabel } from '@mui/material'

import './minor_header.css'

export const MinorHeader = ({search_params={}, handleFilter, pass_action_to_close, set_params}) =>{
    
    const add_tag = (e) => {
        if(e.target.checked){
            set_params({...search_params, tags:[...search_params.tags, e.target.value]})
            e.target.checked = true
        } else{
            set_params({...search_params, tags:search_params?.tags.filter(t => t!==e.target.value)})
            e.target.checked = false
        }
        
    }
    const add_location = (e) => {
        if(e.target.checked){
            set_params({...search_params, location:[...search_params.location, e.target.value]})
            e.target.checked = true
        } else{
            set_params({...search_params, location:search_params?.tags.filter(t => t!==e.target.value)})
            e.target.checked = false
        }
        
    }
    const add_duration = (e) => {
        if(e.target.checked){
            set_params({...search_params, duration:[...search_params.tags, e.target.value]})
            e.target.checked = true
        } else{
            set_params({...search_params, duration:search_params?.tags.filter(t => t!==e.target.value)})
            e.target.checked = false
        }
        
    }

    return (
            <div className='minor_header_bar'>
                <div className=''>
                    <form className='minor_search search_margin flexrow flex_row_wrap' onSubmit={e=>{
                            e.preventDefault()
                            pass_action_to_close()
                            handleFilter(e)
                        }}>
                        <div>
                            {/* <div> */}
                                <Button variant="outlined" type='submit'>Filter</Button>
                           
                        </div>  
                    <div>
                        filter by tags:
                        <div className='minor_header_titles'>
                            <FormControlLabel control={<Checkbox value={'safari'} id='safari' checked={search_params.tags.includes('safari')} onChange={e=>add_tag(e)}/>} label="Safari Tours" />
                            <FormControlLabel control={<Checkbox value={'vacations'} id='vacations' checked={search_params.tags.includes('vacations')} onChange={e=>add_tag(e)} />} label="Vacations/Holidays"/>
                            <FormControlLabel control={<Checkbox value={'day tour'} id='day tour' checked={search_params.tags.includes('day tour')} onChange={e=>add_tag(e)} />} label="Day Tours" />
                            <FormControlLabel control={<Checkbox value={'adventure'} id='adventure' checked={search_params.tags.includes('adventure')} onChange={e=>add_tag(e)} />} label="Adrenaline rush adventures" />
                        </div>
                    </div>
                    <div>
                        filter by locations:
                        <div className='minor_header_titles'>
                            <FormControlLabel control={<Checkbox value={'coast'} id='coast' checked={search_params.location.includes('coast')} onChange={e=>add_location(e)}  />} label="Coastal" />
                            <FormControlLabel control={<Checkbox value={'parks'} id='parks' checked={search_params.location.includes('parks')} onChange={e=>add_location(e)}  />} label="Game parks" />
                            <FormControlLabel control={<Checkbox value={'desert'} id='desert' checked={search_params.location.includes('desert')} onChange={e=>add_location(e)} />} label="Deserts"/>
                            <FormControlLabel control={<Checkbox value={'mountain'} id='mountain' checked={search_params.location.includes('mountain')} onChange={e=>add_location(e)} />} label="Mountain" />
                            <FormControlLabel control={<Checkbox value={'rivers'} id='rivers' checked={search_params.location.includes('rivers')} onChange={e=>add_location(e)} />} label="Rivers and valleys" />
                        </div>
                    </div>
                    <div>
                        filter by Duration:
                        <div className='minor_header_titles'>
                            <FormControlLabel control={<Checkbox value={'1'} id='1' checked={search_params.duration.includes('1')} onChange={e=>add_duration(e)}  />} label="Single Day" />
                            <FormControlLabel control={<Checkbox value={'2'} id='2' checked={search_params.duration.includes('2')} onChange={e=>add_duration(e)} />} label="Two Days"/>
                            <FormControlLabel control={<Checkbox value={'3'} id='3' checked={search_params.duration.includes('3')} onChange={e=>add_duration(e)} />} label="Three Days" />
                            <FormControlLabel control={<Checkbox value={'more'} id='more' checked={search_params.duration.includes('more')} onChange={e=>add_duration(e)} />} label="More than 3 days" />
                        </div>
                    </div>
                    </form>
                </div>
            </div>
        )
}